/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { DeleteRemoveDebtorTokenMutationResponse, DeleteRemoveDebtorTokenPathParams, DeleteRemoveDebtorToken400, DeleteRemoveDebtorToken401 } from "../../models/DeleteRemoveDebtorToken";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getDeleteRemoveDebtorTokenUrl({ debtorCode, uuid }: { debtorCode: DeleteRemoveDebtorTokenPathParams["debtorCode"]; uuid: DeleteRemoveDebtorTokenPathParams["uuid"] }) {
  const res = { method: 'DELETE', url: `/api/v1/debtors/${debtorCode}/tokens/${uuid}` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/tokens/:uuid}
 */
export async function deleteRemoveDebtorToken({ debtorCode, uuid }: { debtorCode: DeleteRemoveDebtorTokenPathParams["debtorCode"]; uuid: DeleteRemoveDebtorTokenPathParams["uuid"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteRemoveDebtorTokenMutationResponse, ResponseErrorConfig<DeleteRemoveDebtorToken400 | DeleteRemoveDebtorToken401>, unknown>({ method : "DELETE", url : getDeleteRemoveDebtorTokenUrl({ debtorCode, uuid }).url.toString(), ... requestConfig })  
  return res.data
}